<!-- eslint-disable no-unused-vars -->
<!-- eslint-disable import/first -->
<!-- eslint-disable no-unused-vars -->
<!-- eslint-disable vue/attribute-hyphenation -->
<template>
  <div class="text-white relative p-[16px]">
    <div v-if="hasValue">
      <div>
        <span class="text-white text-opacity-80">{{ $t('H9049') }}：</span>
        <span class="num font-specialNumber text-[24px] leading-[24px]">{{ postureTest.compositeScore / 10 }}</span>
        <span
          v-if="resultTextObj.composite"
          class="result text-[14px] leading-[20px]"
          :style="{
            color: resultTextObj.composite.color
          }"
          >{{ $t(resultTextObj.composite.i18nKey) }}</span
        >
      </div>
      <div class="text-white text-opacity-80 mt-[12px] text-[14px] leading-[20px]">
        {{
          $t('H9063', {
            name1: postureTest.runposType === 1 ? $t('H9059') : $t('H9058'),
            name2: $t(resultTextObj.strength?.i18nKey),
            name3: $t(resultTextObj.technique?.i18nKey),
            name4: $t(resultTextObj.groundBalance?.i18nKey)
          })
        }}
      </div>
    </div>
    <div v-else>
      <div class="text-[18px] text-bold leading-[24px]">
        {{ $t('H9071') }}
      </div>
      <div class="mt-[10px] text-[14px] text-white text-opacity-80 leading-[20px]">
        {{ $t('H9072') }}
      </div>
    </div>

    <!-- 雷达图 -->
    <div class="w-[160px] flex justify-center relative mt-[16px] mx-auto z-10">
      <div class="z-10 absolute top-0 left-1/2 translate-x-[-50%] text-center">
        <div class="leading-[20px] text-white text-opacity-60 break-normal">
          {{ $t('H9055') }}
        </div>
        <div class="text-[20px] leading-[24px] font-bold">
          {{ !hasValue ? '--' : postureTest.techniqueScore / 10 }}
        </div>
      </div>
      <div class="z-10 absolute top-1/2 left-0 translate-y-[60%] translate-x-[-130%] text-right">
        <div class="leading-[20px] text-white text-opacity-60 break-normal">
          {{ $t('H9056') }}
        </div>
        <div class="text-[20px] leading-[24px] font-bold">
          {{ !hasValue ? '--' : postureTest.strengthScore / 10 }}
        </div>
      </div>
      <div class="z-10 absolute top-1/2 right-0 translate-y-[60%] translate-x-[130%] text-left">
        <div class="leading-[20px] text-white text-opacity-60 break-normal">
          {{ $t('H9057') }}
        </div>
        <div class="text-[20px] leading-[24px] font-bold">
          {{ !hasValue ? '--' : postureTest.balanceScore / 10 }}
        </div>
      </div>
      <div class="relative mt-[50px] w-full h-[160px]">
        <img
          class="absolute top-0 left-0 w-full h-full -z-10"
          :src="assetsRequire('@assets/coros-v2/images/100cc1ed8ac0625fc5d3e0eee49c61e1.png')"
          alt="bg"
        />
        <div
          class="ml-[2px]"
          ref="svgContainer"
        ></div>
      </div>
    </div>

    <!--    tab切换-->
    <template v-if="hasValue">
      <div class="flex-0 text-[15px] flex items-center tabs !mt-[24px] mb-[20px]">
        <div
          v-for="(item, index) in tabs"
          :key="'tab-item-' + index"
          :class="`flex-1 basis-[60px] h-[30px]  flex text-center items-center justify-center text-ellipsis cursor-pointer  tab-item ${
            activeTab === item.key ? 'active' : ''
          }`"
          @click="changeActiveTabItem(item)"
        >
          <span>{{ item.text }}</span>
        </div>
      </div>

      <!--  平衡 -->
      <section v-if="activeTab === TABS_KEYS.BALANCE">
        <div class="flex justify-center border-solid border-0 border-b border-white/5 py-[12px]">
          <section class="relative z-10 flex justify-between">
            <!-- 左脚 -->
            <div class="text-center flex flex-col justify-center h-[96px]">
              <img
                :src="assetsRequire('@assets/coros-v2/images/118cd24206aa58daf9454be12355f144.svg')"
                class="absolute -z-10 w-[48px] h-[96px] block"
              />

              <div class="text-white text-opacity-60 mb-[5px]">
                {{ $t('H9060') }}
              </div>
              <div>
                <span class="relative text-[24px] leading-[24px] font-bold"
                  >{{ resultTextObj.groundBalanceLeft }}
                  <span class="absolute right-[-16px] bottom-[2px] text-white text-opacity-60 text-[14px] leading-[20px]">%</span>
                </span>
              </div>
            </div>
            <div class="text-white text-opacity-40 text-[14px] leading-[20px] mt-[49px] ml-[25px] mr-[19px]"> / </div>
            <!-- 右脚 -->
            <div class="text-center flex flex-col justify-center h-[96px]">
              <img
                :src="assetsRequire('@assets/coros-v2/images/68a6156d63d0978ebac872f60f2fee6b.svg')"
                class="absolute -z-10 w-[48px] h-[96px] block"
              />
              <div class="text-white text-opacity-60 mb-[5px]">
                {{ $t('H9061') }}
              </div>
              <div>
                <span class="relative text-[24px] leading-[24px] font-bold"
                  >{{ resultTextObj.groundBalanceRight }}
                  <span class="absolute right-[-16px] bottom-[2px] text-white text-opacity-60 text-[14px] leading-[20px]">%</span>
                </span>
              </div>
            </div>
          </section>
        </div>
        <!-- 左右脚 -->
        <div class="flex justify-between border-solid border-0 border-b border-white/5 py-[12px]">
          <div class="flex-grow-0">
            <div class="text-white text-opacity-60 leading-[20px] mr-[8px]">
              {{ $t('H9062') }}
            </div>
            <div class="mt[4px] text-[16px]">
              <span class="leading-[20px] font-bold">{{ resultTextObj.groundBalanceDiff }}</span>
              <span class="text-[12px] text-white text-opacity-40">%</span>
            </div>
          </div>
          <!-- 这里的 160 在下面的计算中用到，要同步修改 -->
          <div class="flex-shrink-0 w-[160px] relative">
            <div class="flex w-full mt-[20px]">
              <template
                v-for="(color, idx) in colors2"
                :key="idx"
              >
                <div
                  :class="`relative flex-1 h-[4px] ${idx === 0 ? 'rounded-tr-none rounded-tl-full rounded-bl-full rounded-br-none' : ''} ${
                    idx === 2 ? 'rounded-tl-none rounded-tr-full rounded-br-full rounded-bl-none' : ''
                  }`"
                  :style="{
                    backgroundColor: color,
                    flex: idx === 0 ? '1' : '2'
                  }"
                >
                  <div
                    ref="groundBalanceTextRef"
                    v-if="resultTextObj.groundBalance.order === idx"
                    class="absolute top-[-16px] left-0 text-[12px] leading-[12px] whitespace-nowrap"
                    :style="{
                      color: resultTextObj.groundBalance.color,
                      left: `${resultTextObj.groundBalance.offset}%`,
                      transform: 'translateX(-50%)'
                    }"
                  >
                    {{ $t(resultTextObj.groundBalance.i18nKey) }}
                  </div>
                  <Label
                    v-if="resultTextObj.groundBalance.order === idx"
                    :style="{
                      left: `${resultTextObj.groundBalance.offset}%`,
                      transform: 'translateX(-50%)'
                    }"
                  />
                </div>
                <div class="flex-shrink-0 h-[4px] flex-0 w-[1px] ]"></div>
              </template>
            </div>

            <div class="mt-[4px] flex justify-between text-[12px] text-white text-opacity-40">
              <div>0</div>
              <div>{{ resultTextObj.groundBalanceDiff > 5 ? '>' : '' }}5%</div>
            </div>
          </div>
        </div>
      </section>

      <!-- 技巧 -->
      <section v-if="activeTab === TABS_KEYS.TECHNIQUE">
        <!-- 踏地时间 -->
        <ResultItem
          :fieldTitle="$t('H5009')"
          :data1="postureTest.groundTimeAvg"
          :dataLeft="postureTest.groundTimeLeft"
          :dataRight="postureTest.groundTimeRight"
          unit="ms"
          :result="resultTextObj.groundTime"
        ></ResultItem>

        <!-- 踏地角度 -->
        <ResultItem
          :fieldTitle="$t('H9043')"
          :data1="(postureTest.strikeAngleAvg / 10).toFixed(1)"
          :dataLeft="(postureTest.strikeAngleLeft / 10).toFixed(1)"
          :dataRight="(postureTest.strikeAngleRight / 10).toFixed(1)"
          unit="°"
          :result="resultTextObj.strikeAngle"
        ></ResultItem>

        <!-- 垂直步幅比 -->
        <ResultItem
          :fieldTitle="$t('H5017')"
          :data1="postureTest.vertRatioAvg / 10"
          :dataLeft="postureTest.vertRatioLeft / 10"
          :dataRight="postureTest.vertRatioRight / 10"
          unit="%"
          :result="resultTextObj.scoreVertstride"
        ></ResultItem>
      </section>

      <!-- 力量 -->
      <section v-if="activeTab === TABS_KEYS.STRENGTH">
        <!-- 下肢刚度 -->
        <ResultItem
          :fieldTitle="$t('H5025')"
          :data1="Number((postureTest.legStiffnessAvg / 10) * (isMetric ? 1 : 0.3048)).toFixed(1)"
          :dataLeft="Number((postureTest.legStiffnessLeft / 10) * (isMetric ? 1 : 0.3048)).toFixed(1)"
          :dataRight="Number((postureTest.legStiffnessRight / 10) * (isMetric ? 1 : 0.3048)).toFixed(1)"
          :unit="isMetric ? 'kN/m' : 'kN/ft'"
          :result="resultTextObj.legStiffness"
          reverse
        ></ResultItem>

        <!-- 地反力峰值 -->
        <ResultItem
          :fieldTitle="$t('H9042')"
          :data1="(postureTest.maxForceAvg / 10000).toFixed(2)"
          :dataLeft="(postureTest.maxForceLeft / 10000).toFixed(2)"
          :dataRight="(postureTest.maxForceRight / 10000).toFixed(2)"
          unit="kN"
          :result="resultTextObj.maxForce"
          reverse
        ></ResultItem>
      </section>
    </template>
  </div>
</template>

<script setup>
import { getCurrentInstance, onMounted, computed, watch, nextTick, reactive, ref } from 'vue';
import { assetsRequire } from '@client/helper/asset';
import { drawSvg } from './drawSvg';
import ResultItem from './ResultItem.vue';
import Label from './Label.vue';
import { BALANCE_CONFIG, ELEVATION_CONFIG, colors2 } from './consts';
import { useActivityDetail } from '../../hooks/useActivityDetail';

const { unitType } = useActivityDetail();

const vm = getCurrentInstance();
const t = vm.proxy.$root.$t;
const svgContainer = ref(null);

const TABS_KEYS = {
  TECHNIQUE: 'technique',
  STRENGTH: 'strength',
  BALANCE: 'balance'
};
// const activeTab = ref(TABS_KEYS.STRENGTH)
// const activeTab = ref(TABS_KEYS.BALANCE)
const activeTab = ref(TABS_KEYS.TECHNIQUE);
const tabs = [
  {
    key: TABS_KEYS.TECHNIQUE,
    text: t('H9055')
  },
  {
    key: TABS_KEYS.STRENGTH,
    text: t('H9056')
  },
  {
    key: TABS_KEYS.BALANCE,
    text: t('H9057')
  }
];
function changeActiveTabItem(tab) {
  activeTab.value = tab.key;
}

const props = defineProps({
  postureTest: {
    type: Object,
    default: () => {}
  }
});

const isMetric = computed(() => unitType.value === 0);

const resultTextObj = reactive({
  composite: null,
  technique: null,
  strength: null,

  groundTime: null,
  strikeAngle: null,
  scoreVertstride: null,
  legStiffness: null,
  maxForce: null,
  groundBalance: null
});
const hasValue = ref(false);
function isNoValue(value) {
  return [undefined, null, ''].includes(value);
}
function processScore() {
  if (!props.postureTest) {
    return;
  }

  const { runposType } = props.postureTest;

  // 跑姿特点, 0-无有效数据, 1-地面型跑者, 2-空中型跑者
  if (runposType === 0) {
    return;
  }

  hasValue.value = true;

  const {
    strikeAngleLeft,
    strikeAngleRight,
    groundTimeLeft,
    groundTimeRight,
    vertRatioLeft,
    vertRatioRight,
    legStiffnessLeft,
    legStiffnessRight,
    maxForceLeft,
    maxForceRight
  } = props.postureTest;

  for (const key of [
    'compositeScore',
    'techniqueScore',
    'strengthScore',
    'balanceScore',

    'groundTimeAvg',
    'strikeAngleAvg',
    'vertRatioAvg',
    'legStiffnessAvg',
    'maxForceAvg',
    'groundBalanceAvg'
  ]) {
    if (!isNoValue(props.postureTest[key])) {
      let val = props.postureTest[key];

      // groundBalanceAvg 为左触地平衡均值 % *10
      if (key === 'groundBalanceAvg') {
        resultTextObj.groundBalanceLeft = val / 10;
        resultTextObj.groundBalanceRight = 100 - resultTextObj.groundBalanceLeft;
        const diff = Math.abs((resultTextObj.groundBalanceLeft - resultTextObj.groundBalanceRight).toFixed(1));
        // const diff = 2.9
        resultTextObj.groundBalanceDiff = diff;
        let result;
        if (diff <= 1) {
          result = BALANCE_CONFIG.BALANCE;
          result.offset = (diff / 1) * 100;
        } else if (diff <= 3) {
          result = BALANCE_CONFIG.BALANCE_LIGHT;
          result.offset = ((diff - 1) / (3 - 1)) * 100;
        } else if (diff < 5) {
          result = BALANCE_CONFIG.BALANCE_HEAVY;
          result.offset = ((diff - 3) / (5 - 3)) * 100;
        } else {
          result = BALANCE_CONFIG.BALANCE_HEAVY;
          result.offset = 100;
        }
        if (result.offset > 100) result.offset = 100;
        // console.log(`🔔 result`, JSON.parse(JSON.stringify(result)))
        resultTextObj.groundBalance = result;
      }

      //  	触地时间
      if (key === 'groundTimeAvg') {
        resultTextObj.groundTime = calcScore(groundTimeLeft, groundTimeRight, val, 'groundTimeAvg');
      }
      // 触地角度
      if (key === 'strikeAngleAvg') {
        const result = calcScore(strikeAngleLeft / 10, strikeAngleRight / 10, val / 10, 'strikeAngleAvg');
        resultTextObj.strikeAngle = result;
      }
      //  	垂直步幅比
      if (key === 'vertRatioAvg') {
        const result = calcScore(vertRatioLeft / 10, vertRatioRight / 10, val / 10, 'vertRatioAvg');
        resultTextObj.scoreVertstride = result;
      }
      //  	下肢刚度
      if (key === 'legStiffnessAvg') {
        const result = calcScore(legStiffnessRight / 10, legStiffnessLeft / 10, val / 10, 'legStiffnessAvg');
        resultTextObj.legStiffness = result;
      }
      //  	地反力峰值
      if (key === 'maxForceAvg') {
        const result = calcScore(maxForceRight / 10000, maxForceLeft / 10000, val / 10000, 'maxForceAvg');
        resultTextObj.maxForce = result;
      }

      if (key === 'compositeScore') {
        resultTextObj.composite = calcTextResult(val / 10);
      }
      if (key === 'techniqueScore') {
        resultTextObj.technique = calcTextResult(val / 10);
      }
      if (key === 'strengthScore') {
        resultTextObj.strength = calcTextResult(val / 10);
      }
    }
  }

  if (svgContainer.value) {
    const data = [props.postureTest.techniqueScore / 10, props.postureTest.balanceScore / 10, props.postureTest.strengthScore / 10];
    const svg = drawSvg(data);
    svgContainer.value.appendChild(svg);
  }
}

function calcTextResult(val) {
  // return ELEVATION_CONFIG.EXPERT
  let result;
  if (val >= 90) {
    result = ELEVATION_CONFIG.EXPERT;
    result.offset = ((val - 90) / 10) * 100;
  } else if (val >= 80) {
    result = ELEVATION_CONFIG.EXCELLENT;
    result.offset = ((val - 80) / 10) * 100;
  } else if (val >= 70) {
    result = ELEVATION_CONFIG.GOOD;
    result.offset = ((val - 70) / 10) * 100;
  } else if (val >= 60) {
    result = ELEVATION_CONFIG.NORMAL;
    result.offset = ((val - 60) / 10) * 100;
  } else {
    result = ELEVATION_CONFIG.QUALIFIED;
    result.offset = ((val - 50) / 10) * 100;
  }
  if (result.offset > 100) result.offset = 100;
  return result;
}

let levels = [
  ELEVATION_CONFIG.EXPERT,
  ELEVATION_CONFIG.EXCELLENT,
  ELEVATION_CONFIG.GOOD,
  ELEVATION_CONFIG.NORMAL,
  ELEVATION_CONFIG.QUALIFIED
];
function calcScore(max, min, val, key) {
  const range = (max - min) / 5;
  let level = (val - min) / range;

  let offset = (val - min) % range;

  if (level > 4) {
    if (level >= 5) {
      offset = 100;
    }
    level = 4;
  } else if (level < 0) {
    level = 0;
    offset = 0;
  } else {
    level = Math.floor(level);
    offset = ((val - min) / range - level) * 100;
  }

  // 数值和评价是颠倒的
  if (key === 'legStiffnessAvg') {
    levels = levels.reverse();
  }
  const result = JSON.parse(JSON.stringify(levels[level]));

  result.offset = offset;
  return result;
}

const wrapWidth = 160;
const groundBalanceTextRef = ref(null);
watch(activeTab, checkTextOverflow);
function checkTextOverflow() {
  nextTick(() => {
    if (groundBalanceTextRef.value?.[0]) {
      const el = groundBalanceTextRef.value[0];
      const w = el.offsetWidth / 2;
      const parentWidth = el.parentElement.offsetWidth;
      const { order: currentIndex, offset } = resultTextObj.groundBalance;
      if (currentIndex === 0 && w - (parentWidth * offset) / 100 > 0) {
        el.style.left = 0;
        el.style.transform = 'translateX(0)';
      } else if (currentIndex === 1) {
        // wrapWidth 是整体宽度，减去 2 分割线的宽度
        // 三个区域比例是 1:2:2
        const firstZoneWidth = (wrapWidth - 2) * 0.2;
        const secondZonePartialWidth = (wrapWidth - 2) * 0.4 * (offset / 100);
        const leftOffset = firstZoneWidth + secondZonePartialWidth;
        // 文字超过最左边
        if (w > leftOffset) {
          el.style.left = `-${firstZoneWidth}px`;
          el.style.transform = 'translateX(0)';
        }
      } else if (currentIndex === 2 && w - (parentWidth * (100 - offset)) / 100 > 0) {
        el.style.left = 'unset';
        el.style.right = '0';
        el.style.transform = 'translateX(0)';
      }
    }
  });
}

onMounted(() => {
  processScore();
  checkTextOverflow();
});
</script>

<style lang="scss" scoped>
@import '@client/styles/_mixins.scss';

.tabs {
  .tab-item {
    border: solid 1px rgba(255, 255, 255, 0.1);
    background-color: rgba(255, 255, 255, 0.05);

    &:nth-of-type(n + 1) {
      margin-left: -1px;
    }
    &:nth-of-type(1) {
      border-top-left-radius: 2px;
      border-bottom-left-radius: 2px;
    }
    &:nth-last-of-type(1) {
      border-top-right-radius: 2px;
      border-bottom-right-radius: 2px;
    }
    &.active {
      border: solid 1px rgba(255, 255, 255, 0.2);
      background-color: rgba(255, 255, 255, 0.2);
    }
  }
}
</style>
